import {
  Package,
  Users,
  Award,
  Activity,
  type LucideIcon,
} from "lucide-react";
import { AboutReveal } from "./about-reveal";
import { useSiteLanguage } from "@/lib/useSiteLanguage";
import { statsBarCopy } from "@/lib/aboutPageCopy";

const statsMeta: { icon: LucideIcon; value: string }[] = [
  { icon: Package, value: "5+" },
  { icon: Users, value: "20+" },
  { icon: Award, value: "10+" },
  { icon: Activity, value: "99.9%" },
];

export function StatsBar() {
  const lang = useSiteLanguage();
  const labels = statsBarCopy[lang].labels;

  return (
    <section className="bg-background pb-12 md:pb-16 lg:pb-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <AboutReveal>
          <div className="rounded-[2rem] border border-border bg-muted/70 px-4 py-8 backdrop-blur-sm sm:px-6 md:rounded-full md:px-10 md:py-9 lg:px-14">
            <ul className="grid grid-cols-2 gap-8 md:grid-cols-4 md:gap-0">
              {statsMeta.map((stat, index) => {
                const Icon = stat.icon;
                const label = labels[index];
                return (
                  <li
                    key={label}
                    className={`relative flex flex-col items-center text-center md:flex-row md:items-center md:justify-center md:gap-3 md:text-left ${
                      index < statsMeta.length - 1
                        ? "md:after:absolute md:after:right-0 md:after:top-1/2 md:after:h-10 md:after:w-px md:after:-translate-y-1/2 md:after:bg-border"
                        : ""
                    }`}
                  >
                    <span className="mb-2 flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-foreground shadow-sm md:mb-0 md:h-10 md:w-10">
                      <Icon className="h-4 w-4" strokeWidth={1.5} />
                    </span>
                    <div>
                      <p className="text-xl font-bold tracking-tight text-foreground md:text-2xl">
                        {stat.value}
                      </p>
                      <p className="mt-0.5 text-xs text-muted-foreground md:text-sm">
                        {label}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </AboutReveal>
      </div>
    </section>
  );
}
